export default "__VITE_ASSET__CZbsxyLT__"